import script from "./playes.vue?vue&type=script&setup=true&lang=js"
export * from "./playes.vue?vue&type=script&setup=true&lang=js"

import "./playes.vue?vue&type=style&index=0&id=f151b046&scoped=true&lang=scss"

import exportComponent from "/Users/windy/work/vue/zhibo_am/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f151b046"]])

export default __exports__